import type { ReactNode } from 'react';
import React, { memo } from 'react';

import { FloatingNode, FloatingTree, useFloatingParentNodeId } from '@floating-ui/react';

export const FloatingSmartTree = memo(
    ({ nodeId, children }: { nodeId: string | undefined; children: ReactNode }) => {
        const parentId = useFloatingParentNodeId();
        if (parentId === null) {
            return (
                <FloatingTree>
                    <FloatingNode id={nodeId}>{children}</FloatingNode>
                </FloatingTree>
            );
        }
        return <FloatingNode id={nodeId}>{children}</FloatingNode>;
    }
);

FloatingSmartTree.displayName = 'FloatingSmartTree';
